
    const data = {"name":"src/core/icons/image-plus-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 19c0 .7.13 1.37.35 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v8.35c-.63-.22-1.3-.35-2-.35V5H5v14h8m.96-6.71-2.75 3.54-1.96-2.36L6.5 17h6.85c.4-1.12 1.12-2.09 2.05-2.79l-1.44-1.92M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            